<div class="page">
  <div class="header-page">
    <div class="title">
      Mes points
    </div>
    <div class="search-name">
      Barre de recherche
    </div>
    <div class="search-city">
      Barre de recherche
    </div>
  </div>
</div>
